import { jsx as o } from "react/jsx-runtime";
import { ThemeProvider as m } from "styled-components";
function d({ themeInMode: e, children: r }) {
  return /* @__PURE__ */ o(m, { theme: e, children: r });
}
export {
  d as default
};
